import React from 'react';
import clsx from 'clsx';

import RoundedCheckBox from './RoundedCheckBox';

import styles from './BankAccountsList.module.scss';

interface AccountRowProps {
  accountName: string | null;
  accountNumber: string;
  accountBalance?: number;
  selected?: boolean;
  onClick?: () => void;
}

const AccountRow = ({ accountName, accountNumber, accountBalance, selected, onClick }: AccountRowProps) => (
  <div onClick={onClick} className={clsx(styles.row, { [styles.noSelectable]: !onClick })}>
    {selected !== undefined && <RoundedCheckBox selected={selected} />}
    <div className={styles.rowContent}>
      <div className={styles.heading}>
        <div className={styles.accountName}>{accountName}</div>
        <div className={styles.accountNumber}>(...{accountNumber})</div>
      </div>
      {accountBalance !== undefined && <div className={styles.accountBalance}>${accountBalance}</div>}
    </div>
  </div>
);

export default AccountRow;
